import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import "./index.css";
import Manage from "./chord.js";
import About from "./about.js";
import reportWebVitals from "./reportWebVitals";
import Analyze from "./analyze.js";
import Avatar from "./avatar.js";

ReactDOM.render(
  <React.StrictMode>
    <a href="/chord">chord</a> | <a href="/metronome">metronome</a> |{" "}
    <a href="/analyze">analyse</a>
    <BrowserRouter>
      <Route path="/chord">
        <h1>コードフォーム逆引き🎸</h1>
        <p>
          ギターのフォームからコードを逆引きします。
          <br />
          スマホでも横画面にすればギリ使えるかも…。
        </p>
        <Manage />
      </Route>
      <Route path="/analyze" component={Analyze} />
      <Route path="/metronome" component={Avatar} />
      <About />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
